import React, { FC, useState, useEffect } from "../../../lib/teact/teact";
import TabList from "../../ui/TabList";

import DaiMienTrongConfig from "./daiMienNamTrong";


import './userDaiConfig.scss'
type OwerProp = {
    tinhId: string;
    mienDaiCuoc: number;
    onTabChange: (index: number) => void;
    onDataChange: (fieldName: string, value: any) => void;
    forceUpdate: () => void;
    trigger: string;
}

const UserDaiConfig: FC<OwerProp> = ({
    tinhId,
    mienDaiCuoc, // do không vẽ lại, nên thử ép nhảy qua nhảy lại tab xem có vẽ lại không
    onTabChange,
    onDataChange,
    forceUpdate,
    trigger,
}) => {
    const [state, setState] = useState({
        activeTab: 0,
        mienDaiCuoc: mienDaiCuoc
    })

    const TABS = [
        { type: 'ParserParam', title: 'Miền Nam' },
        { type: 'daiSettting', title: 'Miền Trung' },
    ];
    useEffect(() => {
        const tab = mienDaiCuoc == 3 ? 0 : 1
        setState((prev) => ({ ...prev, mienDaiCuoc: mienDaiCuoc, activeTab: tab }))
        console.log('mien dai cuoc tab thay doi: ')
    }, [mienDaiCuoc, tinhId])
    return <>
        <TabList tabs={TABS} activeTab={state.activeTab}
            onSwitchTab={(index) => {
                const mienDaiCuoc = index == 0 ? 3 : 2
                setState((prev) => {
                    forceUpdate()
                    return { ...prev, activeTab: index, mienDaiCuoc: mienDaiCuoc }
                })
            }} />
        {
            state.mienDaiCuoc == 3 &&
            <DaiMienTrongConfig onDataChange={onDataChange} tinhId={tinhId} mienDaiCuocId={state.mienDaiCuoc}
                forceUpdate={forceUpdate}
                trigger={trigger}
            />
        }
        {
            state.mienDaiCuoc == 2 &&
            <DaiMienTrongConfig onDataChange={onDataChange} tinhId={tinhId} mienDaiCuocId={state.mienDaiCuoc}
                forceUpdate={forceUpdate}
                trigger={trigger}
            />
        }
    </>
}

export default UserDaiConfig